export default "__VITE_ASSET__b3df2b94__"